import "./Collection.css";
import Postman from "../../assets/svg/postman.svg";
import Insomnia from "../../assets/images/insomnia.png";
import Download from "../../assets/svg/download.svg";

function Collection() {
  return (
    <div className="collection-container">
      <div className="hero-section">
        <h1 className='hero-title'>
          Gerencie suas Collections de API: Organização e eficiência no
          desenvolvimento
        </h1>
        <p>Utilize as Collections do Sistema de Registro SPC Grafeno para organizar e gerenciar suas requisições de API de forma estruturada. Basta importar, editar e executar suas requisições, facilitando a documentação e a colaboração entre equipes.</p>
      </div>
      <div className="downloads-container">
      <div className="download-section">
        <h2>Collections da Registradora:</h2>
        <div className="button-area">
          <a href="/collection-postman.json" download="">
            <button className="download-button">
              <img src={Postman} alt="Postman Icon" className="left-icon" />
              <img src={Download} alt="Download Icon" className="right-icon" />
            </button>
          </a>
          <a href="/collection-insomnia.json" download="">
            <button className="download-button">
              <img
                src={Insomnia}
                alt="Insomnia Icon"
                className="left-icon img"
              />
              <img src={Download} alt="Download Icon" className="right-icon" />
            </button>
          </a>
        </div>
      </div>
      <div className="download-section">
        <h2>Collections da Escrituradora:</h2>
        <div className="button-area">
          <a href="/Escrituradora SPC Grafeno - Postman.postman_collection.json" download="">
            <button className="download-button">
              <img src={Postman} alt="Postman Icon" className="left-icon" />
              <img src={Download} alt="Download Icon" className="right-icon" />
            </button>
          </a>
          <a href="/Escrituradora SPC Grafeno - Insomnia.json" download="">
            <button className="download-button">
              <img
                src={Insomnia}
                alt="Insomnia Icon"
                className="left-icon img"
              />
              <img src={Download} alt="Download Icon" className="right-icon" />
            </button>
          </a>
        </div>
      </div>
      </div>
    </div>
  );
}

export default Collection;
